import React from "react";
import ReactDOM from "react-dom/client";
import { MotionConfig } from "framer-motion";
import "./index.css";
import "./DESIGN_SYSTEM/tokens.css";
import App from "./App";
import Layout from "./LAYOUT";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MotionConfig reducedMotion="user">
        <Layout>
          <App />
        </Layout>
      </MotionConfig>
    </BrowserRouter>
  </React.StrictMode>
);
